module.exports = __webpack_public_path__ + "static/media/jennifer-sung.8799c4b9.md";